import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.553 1.106A1 1 0 0 1 8 1h8a1 1 0 0 1 .447.106l6 3A1 1 0 0 1 23 5v6a1 1 0 1 1-2 0V9h-4.58l-.405 4.86L18.693 21H21a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2h2.307l2.678-7.14L7.58 9H3v2a1 1 0 1 1-2 0V5a1 1 0 0 1 .553-.894zM9.587 9l.333 4h4.16l.333-4zm4.993-2H9.42l-.333-4h5.826zm2.007 0H21V5.618l-4.126-2.063zm-9.46-3.445L7.412 7H3V5.618zM14.306 15H9.693l-2.25 6h9.114l-2.25-6Z"
    }, null, -1)
  ]))]))
}
export default { render: render }